import Reveal from "reveal.js";
import { toggleSlideshowPause } from "../state/toggleSlideshowPause";
import { leadingZero } from "../../cpcoc/leadingZero";
export function handleCountdown({ serviceEvent, timerEvent, timerProgress, }) {
    var _a;
    const countdownElement = document.querySelector("#countdown");
    if (!countdownElement) {
        return;
    }
    const minutes = Math.trunc(timerProgress / 60);
    const seconds = timerProgress - minutes * 60;
    const body = document.querySelector("body");
    // if (timerEvent !== "initialized") {
    const msg = document.querySelector(".countdown__msg");
    const value = document.querySelector(".countdown__value");
    if (msg && serviceEvent !== false && serviceEvent.msg && !msg.innerHTML) {
        msg.innerHTML = serviceEvent.msg;
    }
    if (value) {
        value.innerHTML = minutes + ":" + leadingZero(seconds);
    }
    // }
    if (timerEvent === "started" || timerEvent === "updated") {
        body.classList.add("countdown--active");
        if (serviceEvent !== false && serviceEvent.customClass) {
            countdownElement.classList.add(serviceEvent.customClass);
        }
        if ((_a = Reveal.isAutoSliding) === null || _a === void 0 ? void 0 : _a.call(Reveal)) {
            // toggle pause if running
            toggleSlideshowPause();
        }
    }
    else {
        body.classList.remove("countdown--active");
        if (Reveal.isAutoSliding && !Reveal.isAutoSliding()) {
            // toggle pause if NOT running
            Reveal.next();
            toggleSlideshowPause();
        }
    }
}
